import get from 'lodash/get';
import Debug from '../Debug';

const debug = new Debug('ga');

export default {
  init: (user) => {
    if (process.env.NODE_ENV === 'production') {
      if (process.env.GOOGLE_ANALYTICS_ID) {
        if (get(user, ['uid'])) {
          window.ga('create', process.env.GOOGLE_ANALYTICS_ID, { userId: get(user, ['uid']) });
        } else {
          window.ga('create', process.env.GOOGLE_ANALYTICS_ID);
        }
      }
    }
  },

  event: (params = {}) => new Promise((resolve) => {
    const eventCategory = params.category;
    const eventAction = params.action;
    const eventLabel = params.label;
    const eventValue = params.value;
    if (process.env.NODE_ENV === 'production') {
      debug(`💥 GAEV: { EC: '${eventCategory}', EA: '${eventAction}', EL: '${eventLabel}', EV: '${eventValue}' }`);
      window.ga('send', { hitType: 'event', eventCategory, eventAction, ...(eventLabel ? { eventLabel } : {}), ...(eventLabel && eventValue ? { eventValue } : {}), hitCallback: resolve });
    }
    if (process.env.NODE_ENV !== 'production') {
      debug(`💣 GAEV: { EC: '${eventCategory}', EA: '${eventAction}', EL: '${eventLabel}', EV: '${eventValue}' }`);
    }
  }),

  pageview: (params = {}) => new Promise((resolve) => {
    const page = params.page || location.pathname;
    const title = params.title || document.title;
    if (process.env.NODE_ENV === 'production') {
      debug(`💥 GAPV: { DP: '${page}', DT: '${title}' }`);
      window.ga('send', { hitType: 'pageview', page, title, hitCallback: resolve });
    }
    if (process.env.NODE_ENV !== 'production') {
      debug(`💣 GAPV: { DP: '${page}', DT: '${title}' }`);
    }
  }),
};



// WEBPACK FOOTER //
// ./src/app/utils/Visitor/Visitor.js